import React, { useEffect, useRef, useState } from "react";
import NftProjectImg from "../assets/img/common/nft-project-img.png";
import { TbClockHour3 } from "react-icons/tb";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import DetailsTab from "./ProjectView/DetailsTab";
import Timetable from "./ProjectView/Timetable";
import Funders from "./ProjectView/Funders";
import Container from "../components/common/Container";
import {
  useDislikeProjectMutation,
  useGetProjectByIdQuery,
  useLikeProjectMutation,
  usePublishProjectMutation,
  useUnPublishProjectMutation,
} from "../redux/slices/api/projectsApiSlice";
import { addTimeToDate, isExpiredDate, isoToString } from "../utils/dateTool";
import { Bars } from "react-loader-spinner";
import { useChainId, useChains } from "wagmi";
import { CROWDFUNDING_ABI } from "../utils/CROWDFUNDING_ABI";
import erc20ABI from "../utils/erc20.json";
import notify from "../components/common/notify";
import {
  useAnnounceMintCrowdFundingMutation,
  usePrepareCrowdFundingMutation,
  useResumeFundProcessMutation,
} from "../redux/slices/api/fundApiSlice";
import SuccessFullMintedNFTPopup from "../components/projects/SuccessFullMintedNFTPopup";
import useWalletAuth from "../hooks/useWalletAuth";
import { useMemo } from "react";
import { ethers, parseUnits } from "ethers";
import { useFormik } from "formik";
import * as yup from "yup";
import { handleError } from "../hooks/useApi";
import useCheckNetwork from "../hooks/useCheckNetwork";
import { useGetNotificationsQuery } from "../redux/slices/api/userApi";
import {
  allChains,
  contractNetworks,
  currencyIcons,
  getChain,
  getCurrencyKeysByNetwork,
  getNetworkCurrency,
} from "../utils/currencies";
import CountDown from "../components/common/CountDown";
import FlowLoadingPopup from "../components/common/FlowLoadingPopup";
import useSetRequestStatus from "../hooks/useSetRequestStatus";
import { fundInitialStatus } from "../data/flowPopupData";
import { socket } from "../socket";
import ItemActivityTab from "../components/projects/ItemActivityTab";
import useNavigateToProfile from "../hooks/useNavigateToProfile";
import { UN_REGISTERED } from "../Constants";
import UserPlaceHolderImg from "../assets/img/common/user-placeholder-img.png";
import { useDispatch, useSelector } from "react-redux";
import {
  selectGeneral,
  setShowFullscreenImage,
} from "../redux/slices/generalSlice";
import { BsShareFill } from "react-icons/bs";
import ShareModal from "../components/common/ShareModal";
import useHandleFlowPopupError from "../hooks/useHandleFlowPopupError";
import { asyncTimeout, isDecimalWarning } from "../utils/general";
import ResultsTab from "../components/projects/ResultsTab";
import useCheckProjectPermissions from "../hooks/useCheckProjectPermissions";
import { disabledButtonData, projectTabs } from "../data/projects";
import LikeButton from "../components/common/LikeButton";
import DiscussionTab from "../components/projects/DiscussionTab";
import { FaRegComment } from "react-icons/fa";
import useLocalStorage from "../hooks/useLocalStorage";
import ExternalLink from "../components/common/ExternalLink";
import useWindowSize from "../hooks/useWindowSize";

import { useEthersSigner } from "../hooks/useSigner";
import { Tab, TabButton, TabContainer } from "../components/ui/Tab";
import FullScreenImage from "../components/common/FullscreenImage";
import { projectStateColor } from "../Constants/project";
import SelectBox from "../components/common/SelectBox";
import useTokenPrices from "../hooks/useTokenPrices";
import { IoCloseSharp } from "react-icons/io5";
import MetaTags from "../components/common/MetaTags";
const ProjectView = ({ previewData, isPreview, handleClosePreview }) => {
  const { isLoggedIn, showFullscreenImage } = useSelector(selectGeneral);
  const [clickedTab, setClickedTab] = useState(null); // Track the clicked tab
  const handleTabClick = (title) => {
    if (clickedTab === title) {
      setClickedTab(null); 
    } else {
      setClickedTab(title); 
    }
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  let projectViewToken = searchParams.get("token");
  const { hash, search } = useLocation();

  useEffect(() => {
    const updatedHash = hash.replace("#", "");
    if (
      (hash || search) &&
      projectTabs.some((u) => u.url === updatedHash || u.url === search)
    ) {
      setActiveTab(updatedHash || search);
      navigate("", { hash: null, search: null });
    }
  }, [hash, search]);
  const {
    isLoading,
    data: projectData,
    error: getProjectError,
    refetch: refetchProjectData,
  } = useGetProjectByIdQuery(
    {
      id,
      ...(projectViewToken && { token: projectViewToken }),
    },
    {
      skip: !id,
    }
  );

  const {
    toDollar,
    isLoading: tokenPricesLoading,
    fromDollar,
  } = useTokenPrices();

  const { refetch: refetchNotifications } = useGetNotificationsQuery(undefined, {
    skip: !isLoggedIn,
  });
  const [publishProject, { isLoading: publishLoading }] =
    usePublishProjectMutation();
  const [unPublishProject, { isLoading: unPublishLoading }] =
    useUnPublishProjectMutation();
  const [resumeFundProcess] = useResumeFundProcessMutation();

  const [mintLoading, setMintLoading] = useState(false);
  const [fundStatus, setFundStatus] = useState(fundInitialStatus);
  const [isProjectExpired, setIsProjectExpired] = useState(false);
  const [activeTab, setActiveTab] = useState("details");
  const { handleSetStatus } = useSetRequestStatus({
    setRequestStatus: setFundStatus,
  });
  const { setFlowError } = useHandleFlowPopupError({
    initialStatus: fundInitialStatus,
    flowPopupStatus: fundStatus,
    setFlowPopupStatus: setFundStatus,
  });

  const { project, funds, activities, comments } = projectData ?? {};
  const {
    _id: projectId,
    title,
    state,
    ending,
    category,
    blockchain: projectBlockchain,
    creator,
    timeline,
    budget_allocation,
    abstract,
    funding_goal,
    minimum_offer,
    no_minimum_offer,
    token: projectCurrencyToken,
    project_duration: projectDuration,
    publishedAt,
    createdAt,
    keywords,
    likes,
    summary,
    amount_raised,
  } = project ?? previewData ?? {};
  const project_duration = Number(projectDuration);

  const formik = useFormik({
    initialValues: {
      fundAmount: "",
      blockchain: "bnb",
      token: "BNB",
    },
    onSubmit: (values) => {
      handleFundProject();
    },
    validateOnChange: true,
    // initialTouched: { fundAmount: true },
    validationSchema: yup.object().shape({
      fundAmount: yup
        .number("Please enter a valid amount.")
        .required("Please enter a valid amount.")
        .min(1, "Please enter a valid amount greater than 0"),
      blockchain: yup.string().required("blockchain field is required!"),
      token: yup.string().required("token field is required!"),
    }),
  });
  const { blockchain, currencyToken } = useMemo(() => {
    const blockchain = getChain({
      network: formik.values.blockchain,
    })?.network;
    const currencyToken = formik.values.token;
    return {
      blockchain,
      currencyToken,
    };
  }, [formik.values]);

  const { value: inProgressAction, removeValue: removeLocalValue } =
    useLocalStorage("in-progress-action", true);

  // Function to determine whether the fund button should be disabled based on project state and expiration
  const isDisableFund = () => {
    if (
      state === "Closed Call" ||
      state === "Draft" ||
      isProjectExpired
    )
      return true;
  };

  // Reference to track the interval for checking project expiration
  const expiredIntervalRef = useRef(null);

  // Reference to the tabs element

  // Effect to set project expiration and start interval for checking expiration
  useEffect(() => {
    const setExpired = () => {
      if (
        isExpiredDate({
          date: addTimeToDate({
            milliseconds: project_duration,
            days: 0,
            date: publishedAt,
          }),
        })
      ) {
        setIsProjectExpired(true);
      }
    };

    if (projectData) {
      if (!!funds?.find((item) => item?._id === inProgressAction?.fundId))
        removeLocalValue("in-progress-action");
      setExpired();
      expiredIntervalRef.current = setInterval(setExpired, 1000);
    }

    return () => {
      clearInterval(expiredIntervalRef.current);
    };
  }, [projectData, funds]);

  // Effect to set up socket listeners for transfer activities
  useEffect(() => {
    const refetchData = (arg) => {
      console.log("arrrrrrgggg", arg)
      if (arg?.project === id) refetchProjectData();
    };

    socket.on("activity-transfer", refetchData);

    return () => {
      socket.off("activity-transfer", refetchData);
    };
  }, []);

  // State to manage the visibility of the share popup
  const [showSharePopup, setShowSharePopup] = useState(false);

  // Custom hooks to get blockchain-related information
  const chainId = useChainId();
  const chains = useChains();
  const chain = chains.find(c => c.id === chainId);
  const { windowSize } = useWindowSize();

  // State to manage the visibility of the NFT minting success popup
  const [showSuccessFullMintedNFT, setShowSuccessFullMintedNFT] =
    useState(false);

  // Mutations for crowdfunding preparation and announcement of minting
  const [prepareCrowdfunding, { isLoading: prepareCrowdfundingLoading }] =
    usePrepareCrowdFundingMutation();
  const [
    announceMintCrowdFunding,
    { isLoading: announceMintCrowdFundingLoading },
  ] = useAnnounceMintCrowdFundingMutation();

  // Custom hook to check the network status and switch networks
  const { switchNetwork, switchNetworkLoading } = useCheckNetwork();

  // Memoized value for currency token data based on the selected currency token and blockchain
  const currencyTokenData = useMemo(() => {
    return getNetworkCurrency(blockchain, currencyToken);
  }, [currencyToken, blockchain]);

  // State to manage transaction information for funding
  const [txInfo, setTxInfo] = useState(null);

  // Custom hooks for managing user navigation and wallet connection
  const { navigateToProfile } = useNavigateToProfile();
  const { isConnected, ensureWalletReady, walletJustLinked, openConnectModal } = useWalletAuth();

  // Function to handle project closing and opening call
  const handleCloseAndOpenCall = async () => {
    try {
      if (state === "Closed Call") {
        await publishProject({
          id,
        }).unwrap();
      } else {
        await unPublishProject({
          id,
        }).unwrap();
      }
    } catch (error) {
      handleError(error, null, true);
    }
  };

  // Custom hooks to get ethers provider and signer based on the current chain
  const ethersSigner = useEthersSigner({ chainId: chain?.id });

  // Callback function to provide the signer for transactions
  const signerCallback = () => {
    return ethersSigner ?? null;
  };

  // Function to handle the funding process for a crowdfunding project
  const handleFundProject = async () => {
    // Check for a decimal warning in the "fundAmount" field
    if (!isDecimalWarning(formik, "fundAmount")) {
      // Update fund status to reveal approval step if the currency is not native
      if (!currencyTokenData?.isNativeToken) {
        setFundStatus((prev) => ({
          ...prev,
          approve: { ...prev.approve, hidden: false },
        }));
      }

      // Check if wallet is ready (handles OAuth linking, connection, etc.)
      const { ready, reason } = await ensureWalletReady("fund this project");
      if (!ready) {
        handleSetStatus([{ key: "connectWallet", status: "idle" }]);
        return;
      }

      // Remove any existing in-progress action related to funding
      if (!!funds?.find((item) => item?._id === inProgressAction?.fundId))
        removeLocalValue("in-progress-action");

      try {
        // Set wallet connection status to success
        handleSetStatus([{ key: "connectWallet", status: "success" }]);
        setMintLoading(true);

        // Switch the network and handle status accordingly
        let { isSwitched } = await switchNetwork(blockchain, () => {
          handleSetStatus([{ key: "switchNetwork", status: "loading" }]);
        });

        let checkResumeCount = 0;
        let fundData = null;

        // Set status for the preparation step, including network switch success if applicable
        handleSetStatus([
          { key: "prepare", status: "loading" },
          ...(isSwitched ? [{ key: "switchNetwork", status: "success" }] : []),
        ]);

        // Resume the fund process if there is an existing in-progress action
        if (
          inProgressAction?.type === "fund" &&
          inProgressAction?.projectId === id
        ) {
          while (checkResumeCount < 6) {
            checkResumeCount++;
            const response = await resumeFundProcess({
              id: inProgressAction?.fundId,
            }).unwrap();
            if (response?.txHash) {
              checkResumeCount = 0;
              fundData = response;
              break;
            }
            if (
              checkResumeCount > 4 &&
              response?.message === "Operation has been failed."
            ) {
              setMintLoading(false);
              setFundStatus(fundInitialStatus);
              removeLocalValue("in-progress-action");
              return notify(
                "It is not possible to continue the last fund, please try again.",
                "error"
              );
            }
            await asyncTimeout(10000);
          }
        }

        // Prepare crowdfunding data if there is no existing fund data
        let prepareCrowdfundingRes;
        if (!fundData) {
          prepareCrowdfundingRes = await prepareCrowdfunding({
            body: {
              // token : "",
              blockchain: formik.values.blockchain,
              token: formik.values.token,
              amount: Number(formik?.values?.fundAmount),
            },
            id,
          }).unwrap();
        }

        // Set status for preparation success and approval loading if needed
        handleSetStatus([
          { key: "prepare", status: "success" },
          ...(!currencyTokenData?.isNativeToken
            ? [{ key: "approve", status: "loading" }]
            : []),
        ]);

        // Get the signer based on the current network
        const signer = signerCallback();
        if (!signer) throw new Error("Wallet signer is unavailable");
        const signerAddress = await signer.getAddress();

        // Initiate the crowdfunding contract
        const nftContract = new ethers.Contract(
          contractNetworks?.[blockchain].crowdfunding,
          CROWDFUNDING_ABI,
          signer
        );

        let allowance;
        let token;

        // Check and approve spending for non-native tokens before safeMint
        if (!currencyTokenData?.isNativeToken) {
          token = new ethers.Contract(
            currencyTokenData?.info?.contract,
            erc20ABI,
            signer
          );

          allowance = await token.allowance(
            signerAddress,
            contractNetworks?.[blockchain].crowdfunding
          );

          const balance = await token.balanceOf(signerAddress);

          // Check if the fund amount exceeds the user's balance
          if (
            Number(formik?.values?.fundAmount) >
            Number(
              ethers.formatUnits(
                balance.toString(),
                currencyTokenData?.info?.decimals
              )
            )
          ) {
            setMintLoading(false);
            setFundStatus(fundInitialStatus);
            removeLocalValue("in-progress-action");
            return notify("Insufficient balance", "error");
          }
        }

        let announceMintCrowdFundingRes = fundData;

        if (!fundData) {
          // Approve spending for non-native tokens if needed
          if (!currencyTokenData?.isNativeToken) {
            if (
              Number(formik?.values?.fundAmount) >
              Number(
                ethers.formatUnits(
                  allowance.toString(),
                  currencyTokenData?.info?.decimals
                )
              )
            ) {
              const approveTx = await token.approve(
                contractNetworks?.[blockchain].crowdfunding,
                parseUnits(
                  formik?.values?.fundAmount.toString(),
                  currencyTokenData?.info?.decimals
                )
              );
              let awaitedApproveTx = await approveTx.wait();

              allowance = await token.allowance(
                signerAddress,
                contractNetworks?.[blockchain].crowdfunding
              );

              // Check if the custom spending cap is less than the fund amount
              if (
                formik?.values?.fundAmount >
                Number(formik?.values?.fundAmount) >
                Number(
                  ethers.formatUnits(
                    allowance.toString(),
                    currencyTokenData?.info?.decimals
                  )
                )
              ) {
                throw new Error(
                  "Custom spending cap is less than the fund amount!"
                );
              }

              // Check if the approve transaction failed
              if (awaitedApproveTx?.status?.toString() === "0") {
                setFundStatus(fundInitialStatus);
                removeLocalValue("in-progress-action");
                throw new Error("approve transaction failed !");
              }
            }
          }

          // Set status for approval success and mint loading
          handleSetStatus([
            ...(!currencyTokenData?.isNativeToken
              ? [{ key: "approve", status: "success" }]
              : []),
            { key: "mint", status: "loading" },
          ]);

          // Store in-progress action in local storage
          localStorage.setItem(
            "in-progress-action",
            JSON.stringify({
              type: "fund",
              fundId: prepareCrowdfundingRes?.fund_id,
              projectId: id,
            })
          );

          // Initiate the safeMint transaction
          let nftTx = await nftContract.fundProject(
            parseUnits(
              formik?.values?.fundAmount.toString(),
              currencyTokenData?.info?.decimals
            ),
            currencyTokenData?.info?.contract,
            creator?.public_address,
            prepareCrowdfundingRes.IPFS_URI,
            id,
            {
              gasLimit: 1000000,
              ...(currencyTokenData?.isNativeToken && {
                value: parseUnits(
                  formik?.values?.fundAmount.toString(),
                  currencyTokenData?.info?.decimals
                ),
              }),
            }
          );

          await nftTx.wait();

          // Call announceMintCrowdFunding mutation after safeMint completion
          announceMintCrowdFundingRes = await announceMintCrowdFunding({
            body: {
              txHash: nftTx?.hash,
            },
            id: prepareCrowdfundingRes?.fund_id,
          }).unwrap();
        }

        // Set status for approval and mint success
        handleSetStatus([
          ...(!currencyTokenData?.isNativeToken
            ? [{ key: "approve", status: "success" }]
            : []),
          { key: "mint", status: "success" },
        ]);

        // Remove the in-progress action from local storage
        removeLocalValue("in-progress-action");

        // Show a popup to the user when the NFT is successfully minted
        refetchProjectData();
        refetchNotifications();
        notify(announceMintCrowdFundingRes?.message, "success");
        setTxInfo({ ...announceMintCrowdFundingRes, blockchain });
        setShowSuccessFullMintedNFT(true);
        setFundStatus(fundInitialStatus);
      } catch (error) {
        // Handle errors during the funding process
        if (error?.reason === "rejected")
          removeLocalValue("in-progress-action");
        setFlowError(error);
      }
      setMintLoading(false);
    }
  };

  // Memoized variable to track loading states for various funding-related actions
  const fundLoading = useMemo(
    () =>
      switchNetworkLoading ||
      prepareCrowdfundingLoading ||
      announceMintCrowdFundingLoading ||
      mintLoading,
    [
      prepareCrowdfundingLoading,
      announceMintCrowdFundingLoading,
      mintLoading,
      switchNetworkLoading,
    ]
  );

  // Function to navigate to the project edit page with the current project ID
  const navigateToEditPage = () => {
    navigate(`/create-project?edit=${projectId}`);
  };

  // Custom hook to check user permissions for accessing project results and the project itself
  const { hasAccessToResult, hasAccessToProject } = useCheckProjectPermissions({
    projectData: project,
  });

  // Memoized variable to determine the visibility of the project results tab
  const tabs = useMemo(
    () => [
      {
        url: "details",
        component: <DetailsTab data={previewData ?? project} />,
      },
      {
        url: "timetable-budget",
        component: (
          <Timetable
            timeline={timeline}
            budget_allocation={budget_allocation}
            currencyToken={currencyToken}
            createdAt={createdAt}
          />
        ),
      },
      { url: "results", component: <ResultsTab projectData={projectData} /> },
      {
        url: "discussion",
        component: <DiscussionTab projectData={projectData} />,
      },
      {
        url: "contributors",
        component: <Funders funders={funds} />,
      },
      {
        url: "activity",
        component: (
          <ItemActivityTab
            activities={activities}
            currencyToken={currencyToken}
            blockchain={blockchain}
          />
        ),
      },
    ],
    [
      activities,
      blockchain,
      budget_allocation,
      createdAt,
      currencyToken,
      funds,
      project,
      projectData,
      timeline,
      previewData,
    ]
  );

  if (isLoading || tokenPricesLoading) {
    return (
      <div className="w-full min-h-screen flex justify-center items-center bg-gradient-to-b from-whitesmoke to-white">
        <Bars
          height="50"
          width="50"
          color="#8538ff"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  } else if (getProjectError)
    return (
      <div className="w-full h-screen flex flex-col justify-center items-center text-xl font-bold gap-4">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
          <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <span className="text-gray-600">{getProjectError?.data?.message}</span>
      </div>
    );
  else
    return (
      <div
        className={`w-full flex flex-col items-center bg-gradient-to-b from-whitesmoke via-white to-whitesmoke ${
          isPreview
            ? "!rounded-2xl overflow-auto custom-primary-tiny-scroll relative"
            : ""
        }`}
      >
        <MetaTags
          title={title}
          description={`NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects`}
          link={`/projects/${projectId}}`}
          imageCard={abstract}
        />
        {isPreview && (
          <div className="w-full flex justify-between px-6 items-center py-4 bg-gradient-to-r from-amber-100 to-yellow-100 sticky top-0 z-40 shadow-sm">
            <span className="w-11 h-11"></span>
            <span className="text-base font-semibold text-amber-600 abel-font flex items-center gap-2">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Preview Mode
            </span>
            <button
              onClick={handleClosePreview}
              className="h-fit bg-white z-50 p-2 rounded-full shadow-md hover:bg-gray-50 transition-colors"
            >
              <IoCloseSharp color="#454545" size={24} />
            </button>
          </div>
        )}
        <Container
          className={` ${
            isPreview ? "w-full bg-whitesmoke " : "mt-20 mlg:mt-32 "
          }`}
        >
          {/* Action Buttons Bar - Project Creator Controls */}
          {isLoggedIn && (hasAccessToProject || hasAccessToResult) && (
            <div className="w-full flex flex-col gap-3 mb-6">
              {hasAccessToProject && (
                <div className="w-full bg-gradient-to-r from-primary/5 to-purple-50 rounded-2xl p-4 border-l-4 border-primary">
                  <div className="flex items-center gap-2 mb-2">
                    <svg className="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span className="text-sm font-semibold text-primary">Project Creator Controls</span>
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <button
                      onClick={navigateToEditPage}
                      disabled={isLoading}
                      className={`px-5 h-11 bg-gradient-to-r from-primary to-[#7e7cff] flex items-center gap-2 text-white text-sm font-semibold rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 disabled:cursor-not-allowed disabled:opacity-70`}
                    >
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                      Edit Project
                    </button>
                    <button
                      onClick={handleCloseAndOpenCall}
                      disabled={publishLoading || unPublishLoading || isProjectExpired}
                      className={`px-5 h-11 bg-white border-2 border-primary/20 flex items-center gap-2 text-primary text-sm font-semibold rounded-xl hover:bg-primary/5 hover:border-primary/40 transition-all duration-300 disabled:cursor-not-allowed disabled:opacity-50`}
                    >
                      {unPublishLoading || publishLoading ? (
                        <Bars height="20" width="20" color="#8538ff" ariaLabel="bars-loading" visible={true} />
                      ) : state === "Closed Call" ? (
                        <>
                          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
                          </svg>
                          Open Project Call
                        </>
                      ) : (
                        <>
                          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                          </svg>
                          Close Project Call
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
              {hasAccessToResult && state !== "Draft" && (
                <div className="w-full bg-gradient-to-r from-green-50 to-cyan-50 rounded-2xl p-4 border-l-4 border-primary-green">
                  <div className="flex items-center justify-between flex-wrap gap-3">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-primary-green to-[#0dcada] flex items-center justify-center flex-shrink-0">
                        <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-gray-800 mb-1">Share Your Research Results</h4>
                        <p className="text-xs text-gray-600">Keep your community updated with your latest findings and progress</p>
                      </div>
                    </div>
                    <Link
                      to={`/create-result?project-id=${id}&new=true`}
                      className={`px-5 h-11 bg-gradient-to-r from-primary-green to-[#0dcada] flex items-center gap-2 text-white text-sm font-semibold rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap`}
                    >
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                      Submit Results
                    </Link>
                  </div>
                </div>
              )}
            </div>
          )}
          
          {/* Main Project Content */}
          <div className="w-full bg-white rounded-3xl shadow-xl overflow-hidden roboto-font">
            <div className="w-full flex flex-col pb-8">
              {/* Hero Section - Image and Details Side by Side */}
              <section className="w-full flex flex-col mlg:flex-row">
                {/* Project Image */}
                <div className="w-full mlg:w-[55%] xl:w-1/2">
                  <div className="relative aspect-[4/3] mlg:aspect-auto mlg:h-full">
                    <img
                      onClick={() => dispatch(setShowFullscreenImage(true))}
                      src={abstract || NftProjectImg}
                      alt="Project"
                      className="w-full h-full object-cover cursor-pointer"
                    />
                    {/* Status Badge */}
                    <span
                      style={{
                        backgroundColor: projectStateColor[state],
                      }}
                      className="absolute left-4 top-4 rounded-xl text-sm text-white px-4 py-2 font-medium shadow-lg backdrop-blur-sm"
                    >
                      {state}
                    </span>
                    
                    {/* Floating Action Buttons */}
                    {!isPreview && (
                      <div className="absolute right-4 top-4 flex flex-col gap-2">
                        <div className="rounded-2xl bg-white/90 backdrop-blur-sm shadow-lg px-3 py-3 flex flex-col gap-3 items-center">
                          <LikeButton
                            likes={likes}
                            useLikeMutation={useLikeProjectMutation}
                            useDislikeMutation={useDislikeProjectMutation}
                            id={id}
                            likeType="project"
                          />
                          <button
                            onClick={() => {
                              setActiveTab("discussion");
                            }}
                            className="flex flex-col items-center hover:scale-110 transition-transform"
                          >
                            <FaRegComment
                              size={20}
                              className="text-gray-600"
                            />
                            <span className="text-xs mt-0.5 font-medium text-gray-600">
                              {comments?.length}
                            </span>
                          </button>

                          <button 
                            onClick={() => setShowSharePopup(true)}
                            className="hover:scale-110 transition-transform"
                          >
                            <BsShareFill size={18} className="text-primary" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Project Details */}
                <div className="w-full mlg:w-[45%] xl:w-1/2 flex flex-col p-6 mlg:p-8 justify-between gap-6">
                  {/* Title & Category */}
                  <div className="flex flex-col">
                    <h1 className="text-2xl mlg:text-3xl xl:text-4xl font-bold text-secondary leading-tight">
                      {title}
                    </h1>
                    <div className="flex items-center justify-between mt-3 flex-wrap gap-2">
                      <span className="px-4 py-1.5 rounded-full bg-gradient-to-r from-primary/10 to-[#7e7cff]/10 text-primary text-sm font-semibold">
                        {category}
                      </span>
                    </div>
                    
                    {/* Keywords */}
                    {keywords?.length ? (
                      <div className="flex items-center flex-wrap gap-2 mt-4">
                        {keywords?.map((item, index) => (
                          <Link
                            onClick={(e) => e.stopPropagation()}
                            to={`/projects?keywords=${item}`}
                            key={index}
                            className="py-1 px-3 rounded-lg bg-gray-100 text-gray-600 text-sm hover:bg-gray-200 transition-colors"
                          >
                            #{item}
                          </Link>
                        ))}
                      </div>
                    ) : null}
                  </div>
                  
                  {/* Stats Grid */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex flex-col p-4 rounded-2xl bg-gradient-to-br from-primary/5 to-[#7e7cff]/5 shadow-sm hover:shadow-md transition-shadow">
                      <span className="text-gray-500 text-xs uppercase tracking-wide font-medium">Contributors</span>
                      <span className="text-2xl font-bold text-primary mt-1">{funds?.length || 0}</span>
                    </div>
                    <div className="flex flex-col p-4 rounded-2xl bg-gradient-to-br from-gray-50 to-white shadow-sm hover:shadow-md transition-shadow">
                      <span className="text-gray-500 text-xs uppercase tracking-wide font-medium flex items-center gap-1.5">
                        <TbClockHour3 className="text-base" />
                        Deadline
                      </span>
                      <span className="text-lg font-bold text-primary mt-1">
                        {isoToString(
                          addTimeToDate({
                            date: publishedAt,
                            milliseconds: project_duration,
                          })
                        )}
                      </span>
                    </div>
                  </div>
                  
                  {/* Funding Stats */}
                  <div className="flex items-stretch justify-between gap-3 p-5 rounded-2xl bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 shadow-md">
                    <div className="flex flex-col items-center flex-1">
                      <span className="text-gray-500 text-xs uppercase tracking-wide font-medium">Raised</span>
                      <span className="font-bold text-2xl mt-1 text-primary-green">${amount_raised}</span>
                    </div>
                    {category !== "Asian-Based Grant Initiative for DeSci" && (
                      <>
                        <div className="w-px bg-gray-200"></div>
                        <div className="flex flex-col items-center flex-1">
                          <span className="text-gray-500 text-xs uppercase tracking-wide font-medium">Target</span>
                          <span className="font-bold text-2xl mt-1 text-primary">${funding_goal ?? 0}</span>
                        </div>
                      </>
                    )}
                    <div className="w-px bg-gray-200"></div>
                    <div className="flex flex-col items-center flex-1">
                      <span className="text-gray-500 text-xs uppercase tracking-wide font-medium">Min. Funding</span>
                      {no_minimum_offer ? (
                        <>
                          <span className="font-bold text-xl mt-1 text-green-600">No Minimum</span>
                          <span className="text-gray-400 text-xs">any amount accepted</span>
                        </>
                      ) : (
                        <>
                          <span className="font-bold text-xl mt-1 text-secondary">${minimum_offer || 0}</span>
                          <span className="text-gray-400 text-xs">per contribution</span>
                        </>
                      )}
                    </div>
                  </div>
                  
                  {/* Project Links */}
                  {project?.links?.length > 0 && project.links.some(link => link?.length > 0) && (
                    <div className="flex flex-col gap-2">
                      <h6 className="text-sm font-semibold text-gray-600 flex items-center gap-2">
                        <svg className="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                        </svg>
                        Project Links
                      </h6>
                      <div className="flex flex-wrap gap-2">
                        {project?.links?.map((item, index) =>
                          item?.length ? (
                            <ExternalLink
                              key={index}
                              className="text-sm px-3 py-1.5 rounded-lg bg-gray-100 hover:bg-primary/10 text-primary hover:text-primary font-medium transition-all flex items-center gap-1.5 group"
                              href={item}
                            >
                              <svg className="w-3.5 h-3.5 group-hover:scale-110 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                              </svg>
                              <span className="truncate max-w-[150px]">{item.replace(/^https?:\/\//, '').split('/')[0]}</span>
                            </ExternalLink>
                          ) : null
                        )}
                      </div>
                    </div>
                  )}
                  
                  {/* Blockchain/Token Selection for Crowdfunding */}
                  <div className="flex flex-col md:flex-row gap-3">
                      <SelectBox
                        id={"blockchain"}
                        onChange={(e) => {
                          formik.handleChange(e);
                          formik?.setFieldValue(
                            "token",
                            getCurrencyKeysByNetwork(
                              getChain({ network: e.target.value }).network
                            )[0]
                          );
                          formik?.setFieldTouched("blockchain", false);
                        }}
                        options={allChains.map((chain) => ({
                          value: chain.ethersName,
                          title: chain.name,
                        }))}
                        value={formik.values.blockchain}
                        disabled={
                          formik?.values?.visible ||
                          formik?.values?.nft_details?.address
                        }
                        title={"Blockchain"}
                        placeholder={"Select blockchain"}
                        containerClass="w-full md:w-1/2"
                        selectContainerClass="w-full h-11 rounded-xl shadow-sm"
                        formik={formik}
                        onBlur={formik.handleBlur}
                      />
                      <SelectBox
                        id={"token"}
                        options={getCurrencyKeysByNetwork(
                          getChain({ network: formik.values.blockchain })
                            .network
                        ).map((item) => ({
                          value: item,
                          title: item,
                        }))}
                        title={"Token"}
                        placeholder={"Select token"}
                        containerClass="w-full md:w-1/2"
                        selectContainerClass="w-full h-11 rounded-xl shadow-sm"
                        formik={formik}
                        disabled={
                          formik?.values?.visible ||
                          formik?.values?.nft_details?.address
                        }
                        onBlur={formik.handleBlur}
                        icons={currencyIcons}
                        currentIcon={formik?.values?.token}
                        value={formik?.values?.token}
                      />
                    </div>
                  
                  {/* Action Buttons */}
                  {isDisableFund() ? (
                    <div className={`w-full text-gray-600 bg-gradient-to-r from-gray-100 to-gray-50 flex justify-center items-center h-12 rounded-xl font-medium shadow-sm`}>
                      {disabledButtonData[state]}
                    </div>
                  ) : (
                    <form
                      onSubmit={formik.handleSubmit}
                      className="w-full flex flex-col sm:flex-row gap-3 items-end justify-between relative"
                    >
                      {(isPreview || inProgressAction?.projectId !== id) && (
                          <div className="w-full sm:w-1/2 relative">
                            <span className="absolute -top-5 left-1 text-gray-500 text-sm">
                              ≈ ${toDollar({
                                token: currencyToken,
                                amount: formik.values.fundAmount,
                              })}
                            </span>
                            <div
                              className={`w-full h-12 flex items-center text-center rounded-xl overflow-hidden shadow-sm ${
                                formik?.touched?.fundAmount &&
                                formik?.errors?.fundAmount
                                  ? "ring-2 ring-red-500"
                                  : "ring-1 ring-gray-200 focus-within:ring-2 focus-within:ring-primary"
                              } transition-all`}
                            >
                              <input
                                id="fundAmount"
                                type="number"
                                step="any"
                                className="w-full h-full text-center text-lg font-medium border-none outline-none bg-gray-50 focus:bg-white transition-colors"
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "fundAmount",
                                    e.target.value,
                                    true
                                  );
                                }}
                                onBlur={formik.handleBlur}
                                value={formik?.values?.fundAmount}
                                onWheel={(e) => e.target.blur()}
                                placeholder="0.00"
                                min={0}
                                max={100}
                              />
                              <span className="px-4 min-w-fit h-full flex justify-center items-center bg-gray-100 font-medium text-gray-600">
                                {currencyToken}
                              </span>
                            </div>
                          </div>
                        )}

                      {inProgressAction?.projectId === id &&
                        !isPreview && (
                          <button
                            onClick={() => {
                              removeLocalValue("in-progress-action");
                            }}
                            type={"button"}
                            className="flex justify-center items-center h-12 rounded-xl text-primary bg-primary/10 hover:bg-primary/20 font-medium transition-colors w-full sm:w-1/2"
                          >
                            New Fund
                          </button>
                        )}
                      <button
                        onClick={() => {
                          if (isPreview)
                            return notify(
                              "This button is disabled in preview mode!"
                            );
                          if (inProgressAction?.projectId === id) {
                            handleFundProject();
                          }
                        }}
                        type={
                          inProgressAction?.projectId === id
                            ? "button"
                            : "submit"
                        }
                        disabled={
                          fundLoading ||
                            !formik?.isValid ||
                            isDisableFund() ||
                            isDecimalWarning(formik, "fundAmount")
                        }
                        className={`text-white flex justify-center items-center gap-2 font-semibold disabled:opacity-60 h-12 rounded-xl shadow-lg transition-all duration-300 ${
                          fundLoading
                            ? "animate-pulse bg-gradient-to-r from-primary via-[#9c5cff] to-primary"
                            : "bg-gradient-to-r from-primary to-[#7e7cff] hover:shadow-primary/30 hover:scale-[1.02]"
                        } w-full sm:w-1/2`}
                      >
                        {switchNetworkLoading ? (
                          "Switching Network..."
                        ) : fundLoading ? (
                          "Processing..."
                        ) : inProgressAction?.projectId === id && !isPreview ? (
                          "Continue Funding"
                        ) : (
                          <>
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Contribute
                          </>
                        )}
                      </button>

                      {formik?.touched?.fundAmount &&
                        formik?.errors?.fundAmount && (
                          <span className="text-red-500 text-sm absolute -bottom-6 left-0">
                            {formik?.errors?.fundAmount}
                          </span>
                        )}
                      {isDecimalWarning(formik, "fundAmount") && (
                        <span className="text-yellow-600 text-sm absolute -bottom-6 left-0">
                          Maximum 4 decimal places allowed.
                        </span>
                      )}
                    </form>
                  )}
                </div>
              </section>
              
              {/* Tabs Section */}
              <section className="w-full mt-8 px-6 mlg:px-8 pb-8">
                <div className="pt-8">
                  <TabContainer>
                    {projectTabs
                      .map(({ id, title, url, shouldDisableOnPreview }, index) => (
                        <TabButton
                          key={index}
                          url={url}
                          disabled={isPreview && shouldDisableOnPreview}
                          activeTab={activeTab}
                          setActive={setActiveTab}
                          onClick={() => handleTabClick(title)}
                        >
                          <span className="flex items-center gap-1.5">
                            {title}
                            {(title === "Contributors") && (
                              <span
                                className={`ml-1 min-w-[24px] h-6 px-1.5 flex items-center justify-center rounded-full text-xs font-semibold ${
                                  clickedTab === title ? "bg-white text-primary" : "bg-primary/20 text-primary"
                                }`}
                              >
                                {funds?.length || 0}
                              </span>
                            )}
                          </span>
                        </TabButton>
                      ))}
                  </TabContainer>
                  <div className="mt-6">
                    <Tab tabs={tabs} activeTab={activeTab} />
                  </div>
                </div>
              </section>
            </div>
          </div>
          {showSuccessFullMintedNFT && (
            <SuccessFullMintedNFTPopup
              data={{
                ...txInfo,
                //  txHash: The hash that comes from safeMint will be added here later.
              }}
              show={showSuccessFullMintedNFT}
              setShow={setShowSuccessFullMintedNFT}
            />
          )}
          {mintLoading && <FlowLoadingPopup data={fundStatus} />}
          {showSharePopup && (
            <ShareModal
              show={showSharePopup}
              setShow={setShowSharePopup}
              type="project"
              data={{
                id: id, // Project ID for badge generation
                title: title || 'Project',
                description: summary || '',
                image: abstract || null,
                creator: creator?.name || creator?.email || 'Anonymous',
                extra: {
                  goal: funding_goal || 0,
                  currency: projectCurrencyToken || 'USD',
                  raised: amount_raised || 0,
                  method: 'Crowdfunding',
                },
              }}
            />
          )}
          {showFullscreenImage && (
            <FullScreenImage img={abstract || NftProjectImg} />
          )}
        </Container>{" "}
      </div>
    );
};

export default ProjectView;
